import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { useStyles } from './MultiValueRemove.styles';
export function MultiValueRemove(props) {
    const classes = useStyles();
    const parentId = props.selectProps.id;
    const label = props.data.label.toLowerCase();
    const multiValueRemoveId = `${parentId}-delete-${label}`;
    return (React.createElement("div", Object.assign({ id: multiValueRemoveId }, props.innerProps),
        React.createElement(CloseIcon, { className: classes.delete })));
}
//# sourceMappingURL=MultiValueRemove.js.map